export default [
  {
    parentField: undefined,
    currentField: 'activity', 
  },
  {
    parentField: undefined,
    currentField: 'role', 
  }
]